module.exports = __webpack_public_path__ + "images/icon-power-point-files.png";